import apiService from '@/services/apiService';

const actions = {
  getCxReports({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('cx/find-with-paging', payload)
        .then((response) => {
          commit('getCxReports', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCxCSV({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('cx/find-without-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getClaimReason({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('claim-reason')
        .then((response) => {
          commit('getClaimReason', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getClaimRejectReason({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('cx/reject-reason')
        .then((response) => {
          commit('getClaimRejectReason', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getClaimAdminHub({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('cx/adminhub')
        .then((response) => {
          commit('getClaimAdminHub', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCxReport({ commit }, payload) {
    apiService.get(`cx/content/${payload}`)
      .then((response) => {
        commit('getCxReport', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getCxCompare({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`cx/compare/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  getCxLogs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`cx/logs/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  getCxApprove({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`cx/approved-content/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  getCxApproveAutoClaim({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`cx/claim_refund/${payload}`)
        .then((response) => {
          resolve(response);
          console.log(response);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  getCxAcknowledge({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`cx/acknowledge-content/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  postCxEmail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`cx/email/${payload.id}`, payload.formData)
        .then((response) => {
          // commit('postCxComment', payload)
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postCxComment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`cx/comment/${payload.id}`, payload.formData)
        .then((response) => {
          // commit('postCxComment', payload)
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putCxData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`cx/content/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putCxStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`cx/status/${payload.id}`, payload.statusData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putCxAdminHub({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`cx/adminhub-claim/${payload.id}`, payload.adminHubData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putCxDocument({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`cx/document/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putCxTransfer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`cx/transfer-receipt/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteCxTransfer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.delete(`cx/transfer-receipt/${payload.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delComment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.delete(`cx/comment/${payload.id}/${payload.comment_id}`)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  putCxTransferToCE({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log(payload);
      apiService.put(`cx/transfer-bucket/default`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putCxProcessedBy({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`cx/process-content/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  getListBank({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('cx/list-bank')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getClaimUsers({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('cx/claim-users')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  postCxTransferUserTaken({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`cx/transfer-user-taken/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCxPostRefundedAccessLogs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`cx/post-refunded-access-logs/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  getCxSummaryByUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('cx/claim-summary-by-user', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCxProductivity({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('cx/claim-productivity', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  putCxReReview({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`cx/re-review/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  postCxPayClaim({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`cx/pay-claim/${payload}`)
        .then((response) => {
          resolve(response);
          console.log(response);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  putCxClaimExcess({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`cx/claim-excess/submission/${payload}`)
        .then((response) => {
          resolve(response);
          console.log(response);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
};

export default actions;
